import { BaseLogger } from '../BaseLogger';

export class BiAnalyticsLogger extends BaseLogger {
  constructor(isLocalViewer, isBranch, artifactId) {
    super(isLocalViewer, isBranch);
    this.__customerId = artifactId;
  }

  log(event, ...params) {
    if (!this.isLogNeeded(event, ...params)) {
      return;
    }
    event(...params, this.__customerId);
  }
}
